import { API } from '../api';
import {
  ILoginPayLoad,
  ILoginResponse,
  IRegisterPayload,
  IVerifyEmailPayload,
  IVerifyEmailResponse,
} from '../types/authentication';

const endPoint = {
  login: 'v1/identity-service/accounts/login',
  adminLogin: 'v1/identity-service/accounts/cms/login',
  register: 'v1/identity-service/accounts/register',
  verifyEmail: 'v1/identity-service/accounts/email/confirm',
  resendVerifyEmail: 'v1/identity-service/accounts/resend-email-confirmation',
  twofa: 'v1/identity-service/accounts/cms/verify-2fa',
  externalLogin: 'v1/identity-service/accounts/external-login',
};

export const authenticationServices = {
  async login(payload: ILoginPayLoad) {
    const { data } = await API.post<ILoginResponse>(endPoint.login, {
      email: payload.email,
      password: payload.password,
      passCode: 'cabcomeback',
    });
    return data;
  },

  async adminLogin(payload: ILoginPayLoad) {
    const { data } = await API.post<any>(endPoint.adminLogin, payload);
    return data;
  },
  async verify2faCode(email, token) {
    const { data } = await API.post<any>(endPoint.twofa, { email, token });
    return data;
  },

  async register(payload: IRegisterPayload) {
    const { data } = await API.post(endPoint.register, payload);
    return data;
  },

  async verifyEmail(payload: IVerifyEmailPayload) {
    const { data } = await API.get<IVerifyEmailResponse>(endPoint.verifyEmail, {
      params: payload,
    });
    return data;
  },

  async resendVerifyEmail(email: string) {
    const { data } = await API.get(endPoint.resendVerifyEmail, {
      params: {
        email,
      },
    });
    return data;
  },

  async loginWithThirdParty(provider: string, accessToken: string) {
    const { data } = await API.post(
      endPoint.externalLogin,
      { provider, accessToken },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'clean-request': 'no-clean',
        },
      }
    );
    return data;
  },
};
